import isBefore from 'date-fns/isBefore'
import parseISO from 'date-fns/parseISO'

import type {BuildTypeId, NormalizedBuild} from '../../../../../types'
import type {GraphNode} from '../../../PipelinesPages/utils/graph'

export const isReused = (
  build: NormalizedBuild | null | undefined,
  topBuild: NormalizedBuild | null | undefined,
) =>
  build?.startDate != null &&
  topBuild?.queuedDate != null &&
  isBefore(parseISO(build.startDate), parseISO(topBuild.queuedDate))

export const isLeaf = (
  graph: Record<string, GraphNode> | null,
  id: BuildTypeId | null | undefined,
) => id != null && !graph?.[id]?.successors.size

export const isOnlyLeaf = (
  graph: Record<string, GraphNode> | null,
  id: BuildTypeId | null | undefined,
) =>
  graph != null &&
  Object.values(graph).every(node =>
    node.id === id ? isLeaf(graph, node.id) : !isLeaf(graph, node.id),
  )
